<template>
  <el-table
    v-if="showTable"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :ref="tableRef"
    :data="tableData"
    :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
    :cell-style="{border:'1px solid #dcdfe6'}"
    stripe
    :max-height="isPc?(screenHeight-50>600?(screenHeight-50):600):90000"
    style="width:100%;border: 1px solid #dcdfe6;"
    row-key="id"
    lazy
    :load="treePropsLoad"
    :tree-props="{ children: 'children', hasChildren: 'isClick' }"
    :border="!isPc"
  >
    <el-table-column label="序号" :width="isPc?'80':'35'" align="center">
      <template slot-scope="scope">
        <span v-if="scope.row.id==0&&!isPc">全国</span>
        <span v-else>{{ scope.row.id | filterId(type) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="常住地" :width="isPc?'':'42'" align="center">
      <template slot-scope="scope">
        <span>
          {{ scope.row.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column :label="`总样本量\n(主+专)`" align="center">
      <el-table-column prop="totalAmount" :label="'合计'" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="totalPercentDesc" label="占比" :min-width="isPc?'':'52'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column label="主问卷样本量" align="center">
      <el-table-column prop="amount" label="小计" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column label="专题问卷样本量" align="center">
      <el-table-column prop="specialAmount" label="小计" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="publicSpecialAmount" label="公众版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column prop="employmentSpecialAmount" label="从业版" :min-width="isPc?'':'55'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column prop="yearTargetQuantity" label="年度目标数" align="center" :min-width="isPc?'':'55'">
    </el-table-column>
    <el-table-column prop="yearTargetPercentageCompleteStr" label="年度目标完成率" align="center" :min-width="isPc?'86':'55'">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'TesidenceTable',
  props: {
    type: {
      type: Number,
      default: 1
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    showTable: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ''
    },
    tableRef: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    screenHeight: {
      type: Number,
      default: document.body.screenHeight
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  updated() {
  },
  filters: {
    filterId: function (value, type) {
      if(!value) {
        return ' '
      }
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return Number(value)?value:' '
      }else if ( type === 2 && count===1 ) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if ( type === 2 && count===2 ) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  methods: {
    clickRecommend(row) {
      this.$emit('clickRecommend', row);
    },
    createPlacard(row, type) {
      this.$emit('createPlacard', row, type);
    },
    treePropsLoad(tree, treeNode, resolve) {
      // 模拟异步加载子节点数据
      setTimeout(() => {
        const children = tree.childrenList || [];
        resolve(children);
      }, 500);
    }
  }
};
</script>

<style scoped>

@media screen and (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/table/TesidenceTable.vue